module.exports = {"pi":{"clientId":"SDXgs4VjABgmXXA0iLjRyFeMqnYyVwHU"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/dev.config.json
// module id = 830
// module chunks = 0